import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Typography, Box, Container, AppBar } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ellipseBgImg from "../../assets/svgs/miscPageHeaderEllipses.svg";
import graceHillLogo from "../../assets/images/gh_logo_horizontal.png";
import { useTheme } from "@mui/material/styles";
import CopyrightMessage from "../CopyrightMessage/CopyrightMessage";
import visionLogo from "../../assets/images/vision_logo.jpeg";
import { fetchPublicData } from "../../redux/actions/publicActions";

const useStyles = makeStyles(theme => ({
  wrapper: {
    background:
      "radial-gradient(60.91% 107.32% at 77.24% 113.04%, #00AEEF 0%, #262262 100%)"
  },
  header: {
    backgroundImage: `url(${ellipseBgImg})`,
    backgroundPosition: "bottom",
    height: 300,
    color: theme.palette.common.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  appBar: {
    top: "auto",
    bottom: 0,
    zIndex: 1,
    height: 85,
    boxShadow: "none",
    borderTop: `solid 1px ${theme.palette.divider}`,
    backgroundColor: theme.palette.common.white,
    position: "absolute"
  },
  iconContainer: {
    fontSize: "5.5rem",
    opacity: 0.7,
    marginRight: theme.spacing(7.5),
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.5rem",
      marginRight: theme.spacing(2)
    }
  },
  contentContainer: {
    marginBottom: 85,
    display: "flex",
    flexDirection: "column"
  },
  logo: {
    width: 100,
    [theme.breakpoints.down("sm")]: {
      width: 84
    }
  },
  title: {
    "& h1": {
      [theme.breakpoints.down("sm")]: {
        fontSize: "2rem"
      }
    }
  },
  headerContainer: {
    [theme.breakpoints.down("sm")]: {
      padding: 0
    }
  },
  headerBar: {
    height: 72,
    position: "unset"
  },
  visionLogo: {
    height: "100%",
    marginLeft: theme.spacing(3)
  },
  container: {
    "-ms-overflow-y": "scroll"
  }
}));

const Version = ({ version }) => {
  return (
    <Typography
      variant="caption"
      color="textSecondary"
    >{`Version ${version}`}</Typography>
  );
};

const PageFooter = ({ version }) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <AppBar color="default" className={classes.appBar}>
        <Container maxWidth="md">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box display="flex" alignItems="center">
              <img
                src={graceHillLogo}
                alt="Grace Hill Logo"
                className={classes.logo}
              />
              <Box ml={{ xs: 2, sm: 5 }}>
                <CopyrightMessage />
              </Box>
            </Box>
            <Box>
              <Version version={version} />
            </Box>
          </Box>
        </Container>
      </AppBar>
    </React.Fragment>
  );
};

const PageHeader = ({ title, subtitle, startIcon }) => {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      className={classes.wrapper}
    >
      <Box
        className={classes.header}
        px={{ xs: 3, sm: 6 }}
        py={2}
        flexWrap="wrap"
      >
        <Container className={classes.headerContainer} maxWidth="md">
          <Box className={classes.title} display="flex" alignItems="center">
            {startIcon && (
              <Box
                className={classes.iconContainer}
                ml={{ xs: 0, lg: -18.5 }}
                display="flex"
                alignItems="center"
              >
                {startIcon}
              </Box>
            )}
            {title}
          </Box>
          {subtitle && (
            <Box className={classes.subtitle} mt={1}>
              {subtitle}
            </Box>
          )}
        </Container>
      </Box>
    </Box>
  );
};
function MiscPageLayout(props) {
  const { title, subtitle, startIcon, children, version } = props;

  useEffect(() => {
    if (!props.fetched) {
      props.fetchPublicData();
    }
  }, []);
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      minHeight="100vh"
      bgcolor={theme.palette.common.white}
      className={classes.container}
    >
      <AppBar color="default" className={classes.headerBar}>
        <img
          height="47px"
          width="207px"
          alt="Vision Logo"
          src={visionLogo}
          className={classes.visionLogo}
        ></img>
      </AppBar>
      <PageHeader title={title} startIcon={startIcon} subtitle={subtitle} />
      <Container maxWidth="md" className={classes.contentContainer}>
        {children}
      </Container>
      <PageFooter version={version} />
    </Box>
  );
}

MiscPageLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  startIcon: PropTypes.node
};

const mapStateToProps = state => ({
  version: state.publicState.publicData.version,
  fetched: state.publicState.fetched
});

export default connect(mapStateToProps, { fetchPublicData })(MiscPageLayout);
